import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import userPic from "../../assets/images/nav-profile-img.jpeg";
import NavbarPageInfo from "./PageInfoActions";
import NavbarSearchInput from "./SearchInput";

// Component for platform navbar - top nav on desktop
const Navbar = () => {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [crumbList, setCrumbList] = useState(null);
  const [searchParams] = useSearchParams();
  const lastQuestUpdated = searchParams.get("lastUpdated");
  const period = searchParams.get("period");

  // target config
  const targetDashboardActiveTab = useSelector(
    (e) => e.psc.targetDashboardActiveTab
  );

  const userProfile = useSelector((e) => e.profile.userProfile);
  const userRole = userProfile?.type || "";

  let breadCrumbs = [
    {
      route: `/home/dashboard`,
      pageTitle: "Dashboard",
      crumbs: [
        { label: "Customer Admin", link: null },
        { label: "/ Dashboard", link: null },
      ],
    },
    {
      route: `/home/users`,
      pageTitle: "Users",
      crumbs: [
        { label: "Customer Admin", link: null },
        { label: "/ User Management", link: null },
      ],
    },
    {
      route: `/tailored-content/create`,
      pageTitle: "Tailored Content",
      crumbs: [
        { label: "Custom Education", link: null },
        { label: "/ Create", link: null },
      ],
    },
    {
      route: `/tailored-content/list`,
      crumbs: [
        { label: "Custom Education", link: null },
        { label: "/ Custom Assignments", link: null },
      ],
    },
    {
      route: `/tailored-content/${params.contentId}/detail`,
      crumbs: [
        { label: "Custom Education", link: null },
        { label: "/ Create", link: null },
      ],
    },
    {
      route: `/tailored-content/${params.contentId}/questionlisting/${params.userId}`,
      crumbs: [
        { label: "Custom Education", link: null },
        {
          label: "/ Workflow",
          link: `/tailored-content/${params.contentId}/detail`,
        },
        { label: "/ Detail", link: null },
      ],
    },
    {
      route: `/tailored-content/createLearningPointTailoredContent`,
      crumbs: [
        { label: "Custom Education", link: null },
        { label: "/ Create", link: null },
      ],
    },
    {
      route: `/home/users/bulk/upload/${params.UploadStep}/edit/${params.Id}`,
      pageTitle: "Edit User",
      crumbs: [
        {
          label: "User Databases ",
          link: "/home/users",
        },
        {
          label: "/ Bulk Upload",
          link: "/home/users/bulk/upload/step2",
        },
        {
          label: "/ Edit User",
          link: null,
        },
      ],
    },
    {
      route: `/home/users/bulk/upload/${params.UploadStep}`,
      pageTitle: "",
      crumbs: [
        {
          label: "User Database",
          link: "/home/users",
        },
        {
          label: "/ Bulk Upload",
          link: null,
        },
      ],
    },
    {
      route: "/home/users/newuser",
      pageTitle: "Add New User",
      crumbs: [
        { label: "Customer ", link: "/home/users" },
        { label: "/ Add Customer", link: null },
      ],
    },

    {
      route: `/home/users/updateuser/${params.UserId}`,
      pageTitle: "Edit User Details",
      crumbs: [
        { label: "Users ", link: "/home/users" },
        {
          label: "/ Update Customer",
          link: null,
        },
      ],
    },

    {
      route: `/home/reports`,
      pageTitle: "Available Reports",
      crumbs: [{ label: "Customer Admin", link: null }],
    },
    {
      route: `/home/reports/user_engagement`,
      pageTitle: "User Engagement",
      crumbs: [
        { label: "Reports ", link: "/home/reports" },
        {
          label: "/ User Engagement",
          link: null,
        },
      ],
    },
    {
      route: `/home/reports/user_tracker`,
      pageTitle: "User Tracker Report",
      crumbs: [
        { label: "Reports ", link: "/home/reports" },
        {
          label: "/ User Tracker Report",
          link: null,
        },
      ],
    },
    {
      route: `/home/reports/user_compliance`,
      pageTitle: "User Compliance Report",
      crumbs: [
        { label: "Reports ", link: "/home/reports" },
        {
          label: "/ User Compliance Report",
          link: null,
        },
      ],
    },
    {
      route: "/home/files",
      pageTitle: "File Vault",
      crumbs: [{ label: "File Vault", link: null }],
    },
    {
      route: "/home/billing",
      pageTitle: "License Management",
      crumbs: [{ label: "License Management", link: null }],
    },
    {
      route: "/home/targets",
      pageTitle: "Target Management",
      crumbs: [{ label: "Target Management", link: null }],
    },
    {
      route: `/home/targets/reports/${params.ReportType}`,
      pageTitle: "Target Management - Reports",
      crumbs: [
        { label: "Target Management", link: "/home/targets" },
        {
          label: "/ Reports",
          link: null,
        },
      ],
    },
    {
      route: "/home/targets/configurations/create",
      pageTitle: "Target Management - Configuration",
      crumbs: [
        { label: "Target Management", link: "/home/targets" },
        {
          label: "/ Configuration",
          link: null,
        },
      ],
    },
    {
      route: `/home/targets/configurations/edit/${params.ConfigurationId}`,
      pageTitle: "Target Management - Configuration Edit",
      crumbs: [
        { label: "Target Management", link: "/home/targets" },
        {
          label: "/ Configuration Edit",
          link: null,
        },
      ],
    },
    {
      route: "/home/targets/clinical/performance",
      pageTitle: "Target Management - clinical performance",
      crumbs: [
        { label: "Target Management", link: "/home/targets" },
        {
          label: "/ Clinical Performance",
          link: null,
        },
      ],
    },
    {
      route: `/home/targets/clinical/performance/${params.Clinic}`,
      pageTitle: "Target Management - clinical performance",
      crumbs: [
        { label: "Target Management", link: "/home/targets" },
        {
          label: "/ Clinical Performance",
          link: null,
        },
      ],
    },
    {
      route: "/feed/articles",
      pageTitle: `Articles`,
      crumbs: [
        {
          label: `Articles`,
          link: null,
          btnText: "Create Article",
          btnLink: "/feed/articles/create",
        },
      ],
    },
    {
      route: "/feed/articles/create",
      pageTitle: "Create Article",
      crumbs: [
        { label: "Articles", link: "/feed/articles" },
        {
          label: "/ Create",
          link: null,
        },
      ],
    },
    {
      route: `/feed/articles/edit/${params.PostId}`,
      pageTitle: "Edit Article",
      crumbs: [
        { label: "Articles", link: "/feed/articles" },
        {
          label: "/ Edit Article",
          link: null,
        },
      ],
    },
    {
      route: "/feed/vow",
      pageTitle: `Videos`,
      crumbs: [
        {
          label: "VOW",
          link: null,
          btnText: "Create Video",
          btnLink: "/feed/vow/create",
        },
      ],
    },
    {
      route: "/feed/vow/create",
      pageTitle: "Create Video",
      crumbs: [
        { label: "Videos", link: "/feed/vow" },
        {
          label: "/ Create",
          link: null,
        },
      ],
    },
    {
      route: `/feed/vow/edit/${params.PostId}`,
      pageTitle: "Edit Video",
      crumbs: [
        { label: "VOW", link: "/feed/vow" },
        {
          label: "/ Edit Video",
          link: null,
        },
      ],
    },
    {
      route: `/feed/assignment/${params.PostId}`,
      pageTitle: "Assign  Content",
      crumbs: [
        { label: "Assign Content", link: "/feed/assignment" },
        {
          label: "/ Assign Content",
          link: "",
        },
      ],
    },
    {
      route: `/feed/assignment/${params.AssignmentId}`,
      pageTitle: "Content Assignment Details",
      crumbs: [
        { label: "Content Assignment", link: "/feed/assignment" },
        {
          label: "/Details",
          link: "",
        },
      ],
    },
    {
      route: "/feed/pearls/create",
      pageTitle: "Create Pearls",
      crumbs: [
        { label: "Pearls & Tips", link: "/feed/pearls" },
        {
          label: "/ Create Pearls",
          link: null,
        },
      ],
    },
    {
      route: `/feed/pearls/${params.PostId}/edit`,
      pageTitle: "Edit Pearls",
      crumbs: [
        { label: "Pearls & Tips", link: "/feed/pearls" },
        {
          label: "/ Edit Pearl",
          link: null,
        },
      ],
    },
    {
      route: "/feed/tips/create",
      pageTitle: "Create Tips",
      crumbs: [
        { label: "Pearls & Tips", link: "/feed/tips" },
        {
          label: "/ Create Tips",
          link: null,
        },
      ],
    },
    {
      route: `/feed/tips/${params.PostId}/edit`,
      pageTitle: "Edit Tips",
      crumbs: [
        { label: "Pearls & Tips", link: "/feed/tips" },
        {
          label: "/ Edit Tips",
          link: null,
        },
      ],
    },
    {
      route: "/home/user_groups",
      pageTitle: "Total User Groups",
      crumbs: [
        {
          label: "User Groups",
          link: null,
          // btnText: "Create User Group",
          // btnLink: "/home/user_groups/create",
        },
      ],
    },
    {
      route: "/home/user_groups/create",
      pageTitle: "Create User Group",
      crumbs: [
        { label: "User Groups", link: "/home/user_groups" },
        {
          label: "/ Create",
          link: null,
        },
      ],
    },
    {
      route: `/home/user_groups/edit/${params.GroupId}`,
      pageTitle: "Edit User Group",
      crumbs: [
        { label: "User Groups", link: "/home/user_groups" },
        {
          label: "/ Edit",
          link: null,
        },
      ],
    },
    {
      route: `/home/user_groups/bulk/upload/${params.UploadStep}/edit/${params.Id}`,
      pageTitle: "Edit User Group",
      crumbs: [
        {
          label: "User Group Databases ",
          link: "/home/user_groups",
        },
        {
          label: "/ Bulk Upload",
          link: "/home/user_groups/bulk/upload/step2",
        },
        {
          label: "/ Edit User Group",
          link: null,
        },
      ],
    },
    {
      route: "/home/settings",
      pageTitle: "General Settings",
      crumbs: [
        { label: "Account", link: null },
        { label: "/ Settings", link: null },
      ],
    },
    {
      route: "/programs/questions",
      pageTitle: "Questions DB",
      crumbs: [
        {
          label: "Questions DB",
          link: null,
        },
      ],
    },
    {
      route: "/programs/library",
      crumbs: [
        { label: "Program", link: null },
        { label: "/ Library", link: null },
      ],
    },
    {
      route: "/programs/assigned",
      crumbs: [
        { label: "Program", link: null },
        { label: "/ Assigned Programs", link: null },
      ],
    },
    {
      route: `/programs/library/${params.programId}/details`,
      crumbs: [
        { label: "Program", link: null },
        { label: "/ Library", link: null },
      ],
    },
    {
      route: `/programs/questions/create`,
      pageTitle: "Add Question",
      crumbs: [
        { label: "Questions DB", link: "/programs/questions" },
        {
          label: "/ Add New Question",
          link: null,
        },
      ],
    },
    {
      route: `/programs/questions/detail/${params.QuestionId}`,
      pageTitle: "Question Details - " + params.QuestionId,
      crumbs: [
        { label: "Questions Database", link: "/programs/questions" },
        {
          label: "/ Question Details",
          link: null,
        },
      ],
    },
    {
      route: `/programs/questions/detail/${params.QuestionId}/associations`,
      pageTitle: "Trainings Associated to",
      crumbs: [
        { label: "Questions Database", link: "/programs/questions" },
        {
          label: "/ Question Details",
          link: `/programs/questions/detail/${params.QuestionId}`,
        },
        {
          label: "/  Associated Trainings",
          link: null,
        },
      ],
    },
    {
      route: `/programs/questions/${params.QuestionId}/edit`,
      pageTitle: "Edit Question",
      crumbs: [
        { label: "Questions Database", link: "/programs/questions" },
        {
          label: "/ Edit Question",
          link: null,
        },
      ],
    },
    {
      route: `/programs/questions/upload/${params.UploadStep}`,
      pageTitle: "",
      crumbs: [
        {
          label: "Question Database",
          link: "/programs/questions",
        },
        {
          label: "/ Bulk Upload",
          link: null,
        },
      ],
    },
    {
      route: `/programs/questions/upload/${params.UploadStep}/edit/${params.QuestionId}`,
      pageTitle: "Edit Question",
      crumbs: [
        {
          label: "Question Database ",
          link: "/programs/questions",
        },
        {
          label: "/ Bulk Upload",
          link: `/programs/questions/upload/step2?lastUpdated=${lastQuestUpdated}`,
        },
        {
          label: "/ Edit Question",
          link: null,
        },
      ],
    },
    {
      route: "/programs/modules",
      pageTitle: "Program Modules",
      crumbs: [
        {
          label: "Program Modules",
          link: null,
          btnText: "Create Modules",
          btnLink: "/programs/modules/create",
        },
      ],
    },
    {
      route: `/programs/modules/create`,
      pageTitle: "Create Program Module",
      crumbs: [
        { label: "Program Modules", link: "/programs/modules" },
        {
          label: "/ Module Details",
          link: null,
        },
      ],
    },
    {
      route: `/programs/modules/edit/${params.ModuleId}`,
      pageTitle: "Edit Program Module",
      crumbs: [
        { label: "Program Modules", link: "/programs/modules" },
        {
          label: "/ Edit Module",
          link: null,
        },
      ],
    },
    {
      route: "/programs/list",
      pageTitle: "All Programs",
      crumbs: [
        {
          label: "All Programs",
          link: null,
          btnText: "Create Program",
          btnLink: "/programs/list/create",
        },
      ],
    },
    {
      route: `/programs/list/create`,
      pageTitle: "Create Program",
      crumbs: [
        { label: "Programs", link: "/programs/list" },
        {
          label: "/ Create Program",
          link: null,
        },
      ],
    },
    {
      route: `/programs/list/edit/${params.ProgramId}`,
      pageTitle: "Edit Program",
      crumbs: [
        { label: "Programs", link: "/programs/list" },
        {
          label: "/ Edit Program",
          link: null,
        },
      ],
    },
    // New Question Type
    {
      route: `/programs/survey-questions`,
      crumbs: [
        { label: "Survey Management", link: "/programs/survey-questions" },
        {
          label: "/Survey Questions",
          link: null,
          btnText: "Create Modules",
          btnLink: "/programs/modules/create",
        },
      ],
    },
    {
      route: `/programs/survey-questions/${params.questionId}`,
      crumbs: [
        { label: "Survey Management", link: "/programs/survey-questions" },
        {
          label: "/Details",
          link: null,
        },
      ],
    },
    {
      route: `/programs/survey-questions/create`,
      crumbs: [
        { label: "Survey Management", link: "/programs/survey-questions" },
        {
          label: "/Create Survey Question",
          link: null,
        },
      ],
    },
    {
      route: `/programs/survey-modules`,
      crumbs: [
        { label: "Survey Module", link: "/programs/survey-modules" },
        {
          label: "/Modules",
          link: null,
        },
      ],
    },

    {
      route: `/programs/survey-modules/${params.moduleId}`,
      crumbs: [
        { label: "Survey Modules", link: "/programs/survey-modules" },
        {
          label: "/Module Details",
          link: null,
        },
      ],
    },
    {
      route: `/programs/survey-modules/create`,
      crumbs: [
        { label: "Survey Module", link: "/programs/survey-modules" },
        {
          label: new URLSearchParams(window.location.search).get("module_id")
            ? "/Survey Assignment"
            : "/Create",
          link: null,
        },
      ],
    },
    {
      route: `/programs/survey-assignment`,
      crumbs: [
        { label: "Survey Assignment", link: "/programs/survey-assignment" },
        {
          label: "/All Survey Assignment",
          link: null,
        },
      ],
    },
    {
      route: `/programs/survey-assignment/${params.surveyAssignmentId}`,
      crumbs: [
        { label: "Survey Assignment", link: "/programs/survey-assignment" },
        {
          label: "/Details",
          link: null,
        },
      ],
    },
    {
      route: "/tournaments/list",
      pageTitle: "All Tournaments",
      crumbs: [
        {
          label: "Tournaments",
          link: null,
          btnText: "Create Tournament",
          btnLink: "/tournaments/create",
        },
      ],
    },
    {
      route: `/tournaments/create`,
      pageTitle: "Create Tournament",
      crumbs: [
        { label: "Tournaments", link: "/tournaments/list" },
        {
          label: "/ Create",
          link: null,
        },
      ],
    },
    {
      route: "/tournaments/contestlisting",
      pageTitle: "Assigned Contests",
      crumbs: [
        {
          label: "Tournaments",
          link: null,
        },
        {
          label: "/ Contest listing",
          link: null,
        },
      ],
    },
    {
      route: `/tournaments/${params.TournamentId}/edit`,
      pageTitle: null,
      crumbs: [
        { label: "Tournaments", link: "/tournaments/list" },
        {
          label: "/ Edit",
          link: null,
        },
      ],
    },
    {
      route: `/tournaments/${params.TournamentId}/detail`,
      pageTitle: "Tournament Management",
      crumbs: [
        { label: "Tournaments", link: "/tournaments/list" },
        {
          label: "/ Details",
          link: null,
        },
      ],
    },
    {
      route: `/tournaments/${params.TournamentId}/contest`,
      pageTitle: "Tournament Management",
      crumbs: [
        {
          label: "Tournaments Contests",
          link: `/tournaments/${params.TournamentId}/detail`,
        },
        {
          label: "/ Create",
          link: null,
        },
      ],
    },
    {
      route: `/tournaments/${params.TournamentId}/contest/${params.ContestId}/detail`,
      pageTitle: "Contest Assignment Details",
      crumbs: [
        {
          label: "Tournaments Contests",
          link: `/tournaments/contestlisting`,
        },
        {
          label: "/ Preview",
          link: null,
        },
      ],
    },
    {
      route: `/tournaments/${params.TournamentId}/contest/${params.ContestId}/edit`,
      pageTitle: "Tournament Contest",
      crumbs: [
        {
          label: "Tournaments Contests",
          link: `/tournaments/${params.TournamentId}/detail`,
        },
        {
          label: "/ Edit",
          link: null,
        },
      ],
    },
    {
      route: `/programs/modules/${params.ModuleId}/preview`,
      pageTitle: null,
      crumbs: [
        { label: "Program Modules", link: "/programs/modules" },
        {
          label: "/ Module",
          link: null,
        },
      ],
    },
    {
      route: `/programs/${params.ProgramId}/preview`,
      pageTitle: "Program Detail",
      crumbs: [
        { label: "Programs", link: "/programs/list" },
        {
          label: "/ Program Detail",
          link: null,
        },
      ],
    },
    {
      route: `/programs/assignment/${params.ModuleId}/preview`,
      pageTitle: "View Assignment Detail",
      crumbs: [
        { label: "Programs", link: "/programs/assignment" },
        {
          label: "/ Assignment Detail",
          link: null,
        },
      ],
    },
    {
      route: `/programs/assigned/${params.ModuleId}/preview`,
      pageTitle: "View Assignment Detail",
      crumbs: [
        { label: "Assigned Programs", link: "/programs/assigned" },
        {
          label: "/ Assignment Detail",
          link: null,
        },
      ],
    },
    {
      route: "/programs/assignment",
      pageTitle: null,
      crumbs: [
        { label: "Programs Assigned", link: null },
        {
          label: "/ All Programs",
          link: null,
        },
      ],
    },
    {
      route: `/programs/assignment/${params.ModuleId}`,
      pageTitle: "Assign Program",
      crumbs: [
        { label: "Programs", link: "/programs/list" },
        {
          label: "/ Create Program",
          link: null,
        },
      ],
    },
    {
      route: `/programs/library/${params.ModuleId}/assignment`,
      pageTitle: "Assign Program",
      crumbs: [
        {
          label: "Programs Library",
          link: `/programs/library/${params.ModuleId}/details`,
        },
        {
          label: "/ Assign Program",
          link: null,
        },
      ],
    },
    {
      route: `/feed/assignment/${params.AssignmentId}/preview`,
      pageTitle: "Feed Assignment Preview",
      crumbs: [
        { label: "Feed", link: "/feed/assignment/" },
        {
          label: "/ Feed Assignment",
          link: null,
        },
      ],
    },
    {
      route: `/tournaments/create`,
      pageTitle: null,
      crumbs: [
        { label: "Tournament", link: "/tournaments/" },
        {
          label: "/ Create",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors`,
      pageTitle: null,
      crumbs: [
        { label: "Customer Admin ", link: null },
        {
          label: "/ DT Agents",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors/meat-non-compliance-report`,
      pageTitle: null,
      crumbs: [
        {
          label: "DT Sensors",
          link: "/home/dt-sensors/",
        },
        {
          label: "/ Progress Note Compliance Based Report",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors/meat/clinician-compliance-report`,
      pageTitle: null,
      crumbs: [
        {
          label: "Customer Admin",
          link: null,
        },
        {
          label: "/ DT Sensors /",
          link: "/home/dt-sensors/",
        },
        {
          label: "Clinician MEAT Compliance Based Report",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors/meat/clinician-compliance-report/${params.ClinicianId}`,
      pageTitle: null,
      crumbs: [
        {
          label: "Customer Admin",
          link: "/home/dt-sensors/",
        },
        {
          label: "/ DT Sensors /",
          link: "/home/dt-sensors/meat/clinician-compliance-report",
        },
        {
          label: "Progress Note Compliance Based Report",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors/overall-compliance/top-clinics`,
      pageTitle: null,
      crumbs: [
        {
          label: "Customer Admin",
          link: null,
        },
        {
          label: "/ Overall Compliance /",
          link: `/home/dt-sensors/overall-compliance?period=${period}`,
        },
        {
          label: "Clinic",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors/overall-compliance/top-regions`,
      pageTitle: null,
      crumbs: [
        {
          label: "Customer Admin",
          link: null,
        },
        {
          label: "/ Overall Compliance /",
          link: `/home/dt-sensors/overall-compliance?period=${period}`,
        },
        {
          label: "Region",
          link: null,
        },
      ],
    },
    {
      route: `/home/dt-sensors/overall-compliance/top-clinicians`,
      pageTitle: null,
      crumbs: [
        {
          label: "Customer Admin",
          link: null,
        },
        {
          label: "/ Overall Compliance /",
          link: `/home/dt-sensors/overall-compliance?period=${period}`,
        },
        {
          label: "Clinician",
          link: null,
        },
      ],
    },
  ];

  const backExcludedRoutes = [
    `/programs/questions/upload/${params.UploadStep}`,
    `/programs/modules/${params.ModuleId}/preview`,
    "/tournaments/create",
  ];

  function getListingTitle() {
    // Remove '/' at end of location path
    let locationPathName =
      location?.pathname &&
      location.pathname.charAt(location.pathname.length - 1) === "/"
        ? location.pathname.substring(0, location.pathname.length - 1)
        : location?.pathname;
    let listingPageTitle = "Listing";
    if (locationPathName === "/home/targets" && targetDashboardActiveTab <= 1) {
      listingPageTitle = "Dashboard";
    }
    if (locationPathName === "/home/reports") {
      listingPageTitle = "Reports";
    }
    return listingPageTitle;
  }

  function isNavInfoVisible() {
    const hiddenLocations = [
      "/home/targets",
      "/home/targets/configurations/create",
      "/home/files",
      "/home/dashboard",
      "/home/users",
      "/home/billing",
    ];
    const hiddenLocationsWithParams = [
      "/home/targets/reports",
      "/home/targets/configurations/edit",
      "/home/targets/clinical/performance",
    ];
    const locationPathName =
      location?.pathname &&
      location.pathname.charAt(location.pathname.length - 1) === "/"
        ? location.pathname.substring(0, location.pathname.length - 1)
        : location?.pathname;
    const navHiddenLocationWithParams = hiddenLocationsWithParams.some(
      (substring) => locationPathName.includes(substring)
    );
    return navHiddenLocationWithParams
      ? !navHiddenLocationWithParams
      : !hiddenLocations.includes(locationPathName);
  }

  function isSearchVisible() {
    const searchLocations = [
      "/programs/questions",
      "/programs/modules",
      "/programs/modules/create",
      "/programs/modules/edit",
      "/programs/list/create",
      "/programs/list/edit",
      "/tournaments/list",
      "/home/user_groups",
      "/home/user_groups/create",
      `/home/user_groups/edit/${params.GroupId}`,
      "/feed/articles",
      "/feed/vow",
      "/feed/pearls",
      "/feed/tips",
      "/home/files",
      `/tournaments/${params.TournamentId}/contest`,
      `/tournaments/${params.TournamentId}/contest/${params.ContestId}/edit`,
      `/home/dt-sensors/meat-clinician-compliance-report/clinician-compliance-report`,
      `/home/dt-sensors/hcc-pe-contradiction/clinician-report`,
      `/home/dt-sensors/buddy-coding/clinician-report`,
      `/home/dt-sensors/diagnostic-state/clinician-report`,
    ];
    const searchLocationsWithParams = [
      "/programs/modules/edit",
      "/programs/list/edit",
    ];
    const dynamicUrlPatterns = [/^\/tournaments\/list\/[^/]+\/create$/];
    // Remove '/' at end of location path
    let locationPathName =
      location?.pathname &&
      location.pathname.charAt(location.pathname.length - 1) === "/"
        ? location.pathname.substring(0, location.pathname.length - 1)
        : location?.pathname;
    let searchVisible = false;
    const isDynamicMatch = dynamicUrlPatterns.some((regex) =>
      regex.test(locationPathName)
    );
    searchVisible =
      searchLocations.includes(locationPathName) ||
      searchLocationsWithParams.some((substring) =>
        locationPathName.includes(substring)
      ) ||
      isDynamicMatch;

    return searchVisible;
  }

  useEffect(() => {
    let currentLocation = location.pathname.endsWith("/")
      ? location.pathname.slice(0, -1)
      : location.pathname;
    let temp = breadCrumbs.find(
      (ele) => ele.route.toLowerCase() === currentLocation.toLowerCase()
    );
    setCrumbList(temp);
  }, [location]);
  return (
    <div className="dt-ta-nav-wrapper">
      <div className="top_nav_dash d-flex justify-content-between pl-5">
        <div className="dt-ta-nav-head-wrapper">
          {crumbList && crumbList.crumbs.length > 0 ? (
            <div className="nav-head1 d-flex">
              {crumbList &&
                crumbList.crumbs.map((item, index) => {
                  return (
                    <p
                      key={index}
                      className={item?.link ? "" : "nav-h-cr-disabled"}
                      onClick={() => item?.link && navigate(item.link)}>
                      {item.label}
                    </p>
                  );
                })}
              {crumbList.crumbs.length === 1 && (
                <div className="nav-head1-list">
                  {" / " + getListingTitle()}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="right_side_user gap-2">
          <NavbarSearchInput isSearchVisible={isSearchVisible()} />
          <img
            src={
              userProfile && userProfile.profile_image
                ? userProfile.profile_image
                : userPic
            }
            alt="img"
            className="img-fluid img-nav"
          />
          <p className="m-0">
            {userProfile && userProfile.first_name
              ? userProfile.first_name
              : ""}
          </p>
        </div>
      </div>

      {/* Top Page Info and CTA */}
      {isNavInfoVisible() && (
        <NavbarPageInfo
          pageTitle={
            crumbList && crumbList.pageTitle ? crumbList.pageTitle : ""
          }
          pageWithBack={
            !backExcludedRoutes.includes(crumbList?.route) &&
            crumbList?.crumbs?.length > 1 &&
            crumbList.crumbs[crumbList.crumbs.length - 2]?.link
              ? true
              : false
          }
          backPageLink={
            crumbList?.crumbs?.length > 1
              ? crumbList.crumbs[crumbList.crumbs.length - 2]?.link
              : ""
          }
          supportLink={
            crumbList?.crumbs?.length > 0 && crumbList.crumbs[0]?.supportLink
              ? crumbList.crumbs[0]?.supportLink
              : ""
          }
          supportLinkText={
            crumbList?.crumbs?.length > 0 &&
            crumbList.crumbs[0]?.supportLinkText
              ? crumbList.crumbs[0]?.supportLinkText
              : ""
          }
          addCTAText={
            crumbList?.crumbs?.length > 0 && crumbList.crumbs[0]?.btnText
              ? crumbList.crumbs[0]?.btnText
              : "Create"
          }
          addCTALink={
            crumbList?.crumbs?.length > 0 && crumbList.crumbs[0]?.btnLink
              ? crumbList.crumbs[0]?.btnLink
              : ""
          }
        />
      )}
    </div>
  );
};

export default Navbar;
